export default __webpack_public_path__ + "static/media/table-img.9f9d27f4.svg";